import React, { useState } from 'react'

const ExpandableDescription = ({ title, fullText, language }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="text-center">
      <details 
        className="mt-2"
        onToggle={(e) => setIsExpanded(e.target.open)}
      >
        <summary className="cursor-pointer text-[#CEA15F] hover:text-[#B8914F] font-medium transition-colors duration-200 montserrat list-none inline-flex items-center gap-2">
          <span className={`transform transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`}>
            ▶
          </span>
          {language === 'ru' ? 'Читать описание' : 'Read description'}
        </summary>
        <div className="mt-3 text-center">
          <p className="text-sm md:text-base text-gray-700 montserrat leading-relaxed whitespace-pre-line">
            {fullText}
          </p>
        </div>
      </details>
    </div>
  )
}

export default ExpandableDescription
